<template>
	<div class="page-width">
		<div class="full_width">
			<datatable  
				:title="getPageTitle" 
				:response="data" 
				:fields="fields" 
				:filters="filters" 
				:sorters="sorters" 
				:operations="operations" 
				:unique_buttons="unique_buttons" @stats="openStatsModal"
				@create="createNewOffer" @edit_click="edit" @send_document="sendDocument"
				@delete="deleteOffer" @fees="fees" @expenses="expenses" @files="files" @orange="offers_unique_buttons.selectStatusGroup('Orange')" 
				@red="offers_unique_buttons.selectStatusGroup('Red')" @green="offers_unique_buttons.selectStatusGroup('Green')" 
				@past="offers_unique_buttons.toggleQueryParam('past')" @future="offers_unique_buttons.toggleQueryParam('future')">
			</datatable>
			<p class="total_income" v-if="isSuperAdmin && total_income != undefined">TOTAL: <b>{{total_income}}</b></p>
		</div>
	</div>
</template>
<script>
	import { mapGetters, mapMutations } from 'vuex'
	import OffersUniqueButtons from '@/classes/offers_unique_buttons.js'
	import FiltersHelper from '@/classes/filters_helper.js'
	import OffersHelper from '@/classes/offers_helper.js'
	import Datatable from '@/components/Datatable'
	import Reports from '@/classes/reports.js'
	export default {
		name: 'offers',
		data(){
			let offers_helper = new OffersHelper()
			let offers_unique_buttons = new OffersUniqueButtons(this.$router)
			return {
				total_income: undefined,
				offers_unique_buttons,
				filters_helper: new FiltersHelper(),
				offers_helper: new OffersHelper(),
				sorters: [
					{
						designator: 'id',
						value: '-id'
					},
					{
						designator: 'start_date',
						value: 'start_date'
					},
					{
						designator: 'created_at',
						value: '-created_at'
					},
					{
						designator: 'payment_deadline',
						value: 'payment_deadline'
					},
					{
						designator: 'last_document_date',
						value: 'last_document_date'
					}
				],
				filters: [
			        {
			          type: 'multiple',
			          designator: 'statuses',
			          options: offers_helper.getFiltersOptions()
			        },
			        {
			        	type: 'single',
			        	designator: 'env',
			        	options: [
			        		{
			        			text: 'Suitup',
			        			value: 'Suitup',
			        		},
			        		{
			        			text: 'Rebase',
			        			value: 'Rebase',
			        		},
			        		{
			        			text: 'Office',
			        			value: 'Office',
			        		},
			        		{
			        			text: 'Piola',
			        			value: 'Piola',
			        		}
			        	]
			        },
							{
			        	type: 'single',
			        	designator: 'is_fees_applied',
								options: [
									{
										text: 'True',
										value: true
									},
									{
										text: 'False',
										value: false
									}
								]
			        },
			        {
			        	type: 'date',
			        	designator: 'from_date'
			        },
			        {
			        	type: 'date',
			        	designator: 'to_date'
			        }
				],
				fields: [
				    {
				      name: 'Applicant',
				      value: 'applicant_name'
				    },
				    {
				      name: 'Company',
							component: 'CellCompanyPosition',
				      additional_data: {
				      	resource_type: 'Company'
				      },
				    },
				    {
				      name: 'Salary',
				      value: 'salary_display_text'
				    },
				    {
				      name: 'Percentage',
				      value: 'percentage_display_text'
				    },
				    {
				    	name: 'Payment',
				    	value: 'payment'
				    },
				    {
				      name: 'Message',
				      component: 'Field',
			    		additional_data: {
				    		value_path: 'message',
				    		resource_type: 'Offer',
				    		field_type: 'text_area'
				    	}
				    },
						{
							name: 'Recruiters',
				    	component: 'TableCellRecruiters',
						},
				    {
				      name: 'Start Date',
				      value: 'start_date',
				      is_time: true
				    },
						{
				      name: 'Payment deadline',
							component: 'TableCellPaymentDeadline',
				    },
				    {
				      name: 'Last Document Date',
				      value: 'last_document_date',
				      is_time: true
				    },
				    {
				      name: 'Status',
				      component: 'OfferStatus'
				    },
				    {
				    	name: 'Next Contact',
				    	component: 'Field',
				    	additional_data: {
				    		value_path: 'next_contact',
				    		resource_type: 'Offer',
				    		field_type: 'date_time'
				    	}
				    },
				    {
				      name: 'Env',
				      value: 'env'
				    },
				],
				data: [],
				operations: [
					{ name: 'send_document', display_text: 'Send Document' }, 
					{ name: 'Fees' },
					{ name: 'Stats' },
					{ name: 'Expenses' },
					{ name: 'Files' }
				],
				unique_buttons: offers_unique_buttons.getUniqueButtons()
			}
		},
		created(){
			this.$network_utils.getOffers({
				...this.filters_helper.getServerCallFilters(this.filters), 
				company_id: this.$route.query.company_id, 
				sort: this.$route.query.sort || 'start_date',
				past: this.$route.query.past,
				future: this.$route.query.future 
			}).then(response => {
        response = Array.isArray(response) ? response : [response]
        this.total_income = new Reports(response).getTotalIncome()
				this.data = response.map(offer => {
					let salary = offer.salary_verified ? offer.salary : `(${offer.salary})`
					offer.salary_display_text = this.$utils.formatSalary(salary)
					offer.percentage_display_text = offer.percentage_verified ? offer.percentage : `(${offer.percentage})`
					offer.payment = this.$utils.formatSalary(this.$offers_helper.getPayment(offer))
					offer.last_document_date = this.$offers_helper.getLastDocumentDate(offer)
					return offer
				})
			})
		},
		computed: {
			getPageTitle(){
				if(this.$route.query.company_id){
					return this.$route.query.company_name + ' Offers'
				}
				return 'Offers'
			},
			...mapGetters('general', ['isSuperAdmin'])
		},
		methods: {
			createNewOffer(){
				this.createModal({
					component_name: 'OfferForm',
					modal_title: 'Create New Offer',
					is_create: true
				})
			},
			edit(data){
				this.createModal({
					component_name: 'OfferForm',
					modal_title: this.getOfferModalTitle(data),
					data
				})
			},
			getOfferModalTitle(offer){
				return offer.applicant_name + ' - ' + offer.company.name
			},
			deleteOffer(delete_data){
				let offer_title = this.getOfferModalTitle(delete_data)
				this.createModal({
					designator: 'delete-prompt',
					component_name: 'DeletePrompt',
					modal_title: 'Delete ' + offer_title,
					item_name: offer_title,
					method: 'deleteOffer',
					method_params: { id: delete_data.id }
				})
			},
			sendDocument(data){
				this.createModal({
					component_name: 'SendDocumentForm',
					modal_title: 'שליחת מסמך - ' + this.getOfferModalTitle(data),
					data,
				})
			},
			fees(data){
				this.createModal({
					component_name: 'OfferFeesForm',
					modal_title: 'Fees - ' + this.getOfferModalTitle(data),
					data
				})
			},
			openStatsModal(data){
				this.createModal({
					component_name: 'ResourceStatsForm',
					modal_title: 'Stats - ' + this.getOfferModalTitle(data),
					resource_type: 'Offer',
					resource_id: data.id
				})	
			},
			expenses(data){
				this.createModal({
					component_name: 'OfferExpensesForm',
					modal_title: 'Expenses - ' + this.getOfferModalTitle(data),
					data
				})
			},
			files(data){
				this.createModal({
					component_name: 'FilesModal',
					modal_title: `Files - ${this.getOfferModalTitle(data)}`,
					resource_id: data.id,
					resource_type: 'Offer'
				})
			},
			...mapMutations('modals', ['createModal'])
		},
		components: {
			Datatable
		}
	}
</script>
<style scoped>
	.company_offers_only_text{
		width: 100%;
		text-align: center;
	}
	.total_income {
		margin-bottom: 30px;
	}
</style>
